import { Fragment } from "react";
import { Box, Typography, Divider } from "@mui/material";
import { getAssessmentTimeSpentSegments } from "../../../../utils/assessmentTimeLeft";
import {
  QuizResultsCircular,
  type AssessmentRunningScoreBreakdown,
} from "../../quiz-results-circular/quiz-results-circular";
import { LessonBarChart } from "../../lesson-bar-chart/lesson-bar-chart";
import {
  containerStyle,
  headerContainerStyle,
  statisticTitleStyle,
  congratulationTextStyle,
  dividerContainerStyle,
  dividerStyle,
  timeContainerStyle,
  timeTextStyle,
  timeLabelStyle,
  timeSegmentsRowStyle,
  timeSegmentStyle,
  timeSegmentValueStyle,
  timeSegmentLabelStyle,
  timeSegmentSeparatorStyle,
  chartContainerStyle,
} from "./styles";

interface QuizFinishBlockProps {
  totalAnswers: number;
  // Time spent in seconds
  timeSpent: number;
  scoresEarned?: number;
  totalMaxScore?: number;
  bonusScore?: number;
  scoreBreakdown?: AssessmentRunningScoreBreakdown | null;
  hideTimeSpent?: boolean;
  assessmentData?: {
    scoresEarned: number;
    totalMaxScore: number;
    bonusScore?: number;
    focus: string;
  };
}

export const QuizFinishBlock = ({
  totalAnswers,
  timeSpent,
  scoresEarned,
  totalMaxScore,
  bonusScore,
  scoreBreakdown = null,
  hideTimeSpent = false,
  assessmentData,
}: QuizFinishBlockProps) => {
  const timeSegments = getAssessmentTimeSpentSegments(timeSpent);

  return (
    <Box sx={containerStyle}>
      <Box sx={headerContainerStyle}>
        <Typography sx={statisticTitleStyle}>Your Statistics</Typography>
        <Typography sx={congratulationTextStyle}>
          Congratulations! You have successfully completed the test
        </Typography>
        <QuizResultsCircular
          totalAnswers={totalAnswers}
          isFinish
          scoresEarned={scoresEarned}
          totalMaxScore={totalMaxScore}
          bonusScore={bonusScore ?? assessmentData?.bonusScore}
          scoreBreakdown={scoreBreakdown}
        />
      </Box>

      <Box sx={dividerContainerStyle}>
        <Divider sx={dividerStyle} />
      </Box>

      <Box sx={timeContainerStyle}>
        {!hideTimeSpent && (
          <Box sx={timeTextStyle}>
            <Typography sx={timeLabelStyle}>
              🕔{" "}
              {assessmentData
                ? "Time spent in the Contest"
                : "Time spent in the Pre-assessment"}
            </Typography>
            <Box sx={timeSegmentsRowStyle}>
              {timeSegments.map((segment, index) => (
                <Fragment key={`${segment.label}-${index}`}>
                  {index > 0 ? (
                    <Typography sx={timeSegmentSeparatorStyle}>:</Typography>
                  ) : null}
                  <Box sx={timeSegmentStyle}>
                    <Typography sx={timeSegmentValueStyle}>
                      {segment.value}
                    </Typography>
                    <Typography sx={timeSegmentLabelStyle}>
                      {segment.label}
                    </Typography>
                  </Box>
                </Fragment>
              ))}
            </Box>
          </Box>
        )}

        <Box sx={chartContainerStyle}>
          <LessonBarChart assessmentData={assessmentData} />
        </Box>
      </Box>
    </Box>
  );
};

export default QuizFinishBlock;
